import { graphql } from 'gatsby'
import React from 'react'
import MenuItemGroup, {
  MenuItemGroupContent,
  MenuItemGroupItem,
} from 'src/components/organisms/productRouting/menuItemGroup'
import {
  PrismicMenuItem,
  PrismicPageDataBodyMenuItemGroup,
  PrismicPageDataBodyMenuItemGroupItem,
} from 'src/typings/generated/graphql'

type Props = {
  slice: PrismicPageDataBodyMenuItemGroup
}

const MenuItemGroupSlice = ({ slice }: Props) => {
  const items: MenuItemGroupItem[] = []
  slice.items.forEach((item: PrismicPageDataBodyMenuItemGroupItem) => {
    if (item.menu_item?.document)
      items.push({
        menuItem: item.menu_item.document as PrismicMenuItem,
      })
  })

  const content: MenuItemGroupContent = {
    anchor: slice.primary.anchor ?? undefined,
    headline: slice.primary.headline ?? undefined,
    link: slice.primary.link?.url ? slice.primary.link : undefined,
    items: items ?? undefined,
  }
  return <MenuItemGroup content={content} />
}

export default MenuItemGroupSlice

export const MenuItemGroupFragment = graphql`
  fragment PageDataBodyMenuItemGroup on PrismicPageDataBodyMenuItemGroup {
    primary {
      anchor
      headline
      link {
        url
        target
      }
    }
    items {
      menu_item {
        type
        link_type
        document {
          ... on PrismicMenuItem {
            data {
              name
              description {
                richText
              }
              image {
                alt
                gatsbyImageData
                url
              }
            }
          }
        }
      }
    }
  }
`
